
define(function (require) {
    "use strict";

    var LE = require("app");
    var ApiResources = require("assets/data/apiResources.json");
    var BaseModel = require("models/BaseModel");

    var FacebookExtendAccessTokenModel = {};

    var KEYS = {
        ACCESS_TOKEN: "access_token"
    };

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        FacebookExtendAccessTokenModel = BaseModel.extend({
            KEYS: KEYS,
            name: "FacebookExtendAccessTokenModel",
            resource: ApiResources.MessagingGateway.FBAccessTokenService,
            getAccessToken: function(){
                return this.get(KEYS.ACCESS_TOKEN);
            },

        });
    }

    LE.module("LEManager", moduleDefinition);

    FacebookExtendAccessTokenModel.KEYS = KEYS;

    return FacebookExtendAccessTokenModel;
});

